export default {
  loading(state, loading) {
    state.loading = loading;
  }
};
